<ng-container *ngIf="vm$ | async as vm"
  ><div class="container">
    <ng-container [ngSwitch]="vm.transactionStatus">
      <ng-container *ngSwitchCase="TransactionStatus.POLLING">
        <rd-shared-fulfillment-processing-loader></rd-shared-fulfillment-processing-loader>
      </ng-container>

      <ng-container *ngSwitchCase="TransactionStatus.SUCCESS">
        <rd-tcv2-success-points-transaction-status
          [pointsTransferOrder]="
            vm.order!
          "></rd-tcv2-success-points-transaction-status>

        <rd-tcv2-success-detail
          [pointsTransferOrder]="vm.order!"
          [loyaltyProgram]="vm.pointsTransferLoyaltyProgram">
        </rd-tcv2-success-detail>
        <rd-shared-success-buttons
          [status]="vm.successButtonsStatus"
          [successButtons]="successButtons"></rd-shared-success-buttons>
      </ng-container>

      <ng-container *ngSwitchCase="TransactionStatus.FAIL">
        <div class="loading-background">
          <rd-shared-error-sign></rd-shared-error-sign>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="TransactionStatus.LOADING">
        <div class="loading-background">
          <rd-shared-spinner></rd-shared-spinner>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
